/**
 * The Advertising Terms checkbox on the booking form (kitecorp/transferify-ui#2602).
 *
 * Its accessible name is the whole acceptance sentence, which is rich text with the terms link inside
 * it (`sponsorConsent.acceptTerms`), so no single catalog string names the control. The e2e specs
 * therefore address it by this id, the way the checkout consent is addressed, and this constant is
 * the one place the id is spelled.
 */
export const SPONSOR_TERMS_CONSENT_TESTID = "sponsor-terms-consent";
